export default __webpack_public_path__ + "static/media/DinnerMenu.eadfd3e4.jpg";